<template>
  <div class="box">
    <div class="up">
      <div class="item bg-color-black">
        <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="chart-area" class="text-icon"></icon>
        </span>
          <div class="d-flex">
            <span class="fs-xl text mx-2">在线设备</span>
          </div>
        </div>
        <div class="d-flex jc-center body-box water">
          <dv-water-level-pond class="dv-wa-le-po" :config="water"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      water: {
        data: [50, 60],
        shape: 'roundRect',
        formatter: '{value}%',
        waveNum: 2
      },
    }
  }

}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/box';

.water {
  //width: 300px;

  .dv-wa-le-po {
    height: 120px;
  }
}



//#center {
//  display: flex;
//  flex-direction: column;
//  //padding: 2%;
//  margin: 1%;
//
//  .up {
//    width: 100%;
//    height: 100%;
//    display: flex;
//    flex-wrap: wrap;
//    justify-content: space-around;
//
//    .bg-color-black {
//      border-radius: 10px;
//    }
//
//    .item {
//      width: 100%;
//      height: 100%;
//    }
//
//    .text {
//      color: #c3cbde;
//    }
//
//    .body-box {
//      border-radius: 10px;
//      overflow: hidden;
//
//
//    }
//  }
//}
</style>
